import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.475 15.029a9 9 0 1 0 -7.962 5.957","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

/**
 * IconCircleMinus2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY2xlLW1pbnVzLTIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIwLjQ3NSAxNS4wMjlhOSA5IDAgMSAwIC03Ljk2MiA1Ljk1NyIgLz4KICA8cGF0aCBkPSJNMTYgMTloNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/circle-minus-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircleMinus2 = createReactComponent('outline', 'circle-minus-2', 'CircleMinus2', __iconNode);

export default IconCircleMinus2;